import { Button, Separator, Surface } from '@heroui/react'
import { Minus, Plus } from 'lucide-react'
import { type ReactNode } from 'react'

export type StepperProps = {
  onIncrement: () => void
  onDecrement: () => void
  onIncrementPressStart?: () => void
  onIncrementPressEnd?: () => void
  onDecrementPressStart?: () => void
  onDecrementPressEnd?: () => void
  isIncrementDisabled?: boolean
  isDecrementDisabled?: boolean
  incrementLabel?: string
  decrementLabel?: string
  children: ReactNode
}

export const Stepper = ({
  onIncrement,
  onDecrement,
  onIncrementPressStart,
  onIncrementPressEnd,
  onDecrementPressStart,
  onDecrementPressEnd,
  isIncrementDisabled = false,
  isDecrementDisabled = false,
  incrementLabel = 'Increase',
  decrementLabel = 'Decrease',
  children,
}: StepperProps) => (
  <Surface
    variant="transparent"
    className="flex-1 flex rounded-2xl overflow-hidden border"
  >
    <div className="flex-1 flex items-stretch">
      <Button
        isIconOnly
        variant="ghost"
        className="h-full w-14 rounded-none rounded-l-2xl"
        onPress={onDecrement}
        onPressStart={onDecrementPressStart}
        onPressEnd={onDecrementPressEnd}
        isDisabled={isDecrementDisabled}
        aria-label={decrementLabel}
      >
        <Minus className="size-6" />
      </Button>
      <Separator orientation="vertical" />
      <div className="flex-1 flex p-4">{children}</div>
      <Separator orientation="vertical" />
      <Button
        isIconOnly
        variant="ghost"
        className="h-full w-14 rounded-none rounded-r-2xl"
        onPress={onIncrement}
        onPressStart={onIncrementPressStart}
        onPressEnd={onIncrementPressEnd}
        isDisabled={isIncrementDisabled}
        aria-label={incrementLabel}
      >
        <Plus className="size-6" />
      </Button>
    </div>
  </Surface>
)
